import VanityCabinetSubPartCommon from "./vanityCabinetSubPartCommon";
import {Vanity} from "../../parts/vanity";
import {createParentPositions, VANITY_TYPES} from "../../constants";

export default class DrawerPull extends VanityCabinetSubPartCommon {

  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_drawer_pull';
    this.partName = 'Drawer Pull';
    this.translateId = "visualizer.bathroom.vanity.vanity_drawer_pull";
    this.visible = [Vanity.Types.Custom];
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  disabledClick() {
    this.toggleLayerPositions();
  }

  hideLayerCondition() {
    const vanityParent = this.getParent();
    return !vanityParent.vanityCabinet || !vanityParent.vanityCabinet.activeFeature || vanityParent.vanity_type !== VANITY_TYPES.vanity_cabinet
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const activeMatchingVanity = this.getParent().getActiveSkuFromRelatedItem(VANITY_TYPES.vanity_cabinet);
    if (activeMatchingVanity) {
      conditions.push({
        propName: "MatchingFeature",
        propValue: activeMatchingVanity
      });
    }
    return conditions
  }

  canDisplayDemoPoint() {
    return this.getParent().vanity_type === VANITY_TYPES.vanity_cabinet
  }

}
